import React from "react";
import { Typography as MuiTypography } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    divider: {
        borderBottom: "1px solid var(--grey-keyline)",
        lineHeight: 0,
        width: "100%",
        marginTop: 10,
        marginLeft: 5,
    },
    noBottomPadding: {
        paddingBottom: 0,
    },
    containerForTitle: {
        display: "flex",
        whiteSpace: "noWrap",
        height: "100%",
        alignItems: "center",
    },
}));

const Title = withStyles(() => ({
    root: {
        fontFamily: "Arial",
        fontSize: 18,
        fontWeight: 400,
        marginTop: 10,
        color: "var(--text-medium)",
    },
}))(MuiTypography);

export const Header = (props) => {
    const classes = useStyles();

    return (
        <div className={classes.containerForTitle}>
            <Title>{props.children}</Title>
            <div className={classes.divider} />
        </div>
    );
};
